import { useEffect } from 'preact/hooks';
import { useRouterState } from '@tanstack/react-router';

export function useDocumentTitle(title: string) {
  const pageType = useRouterState({
    select: (s) => s.matches.find((m) => m.staticData.pageType)?.staticData.pageType,
  });

  useEffect(() => {
    const previous = document.title;
    document.title = pageType === 'marketing'
      ? `Goalpost | ${title}`
      : `${title} — Goalpost`;
    return () => {
      document.title = previous;
    };
  }, [title, pageType]);
}
